// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2OmV7","amount":"Amount_amount__3veDy","tip":"Amount_tip__4jIEk","tipHeader":"Amount_tipHeader__12oLE","tipsWrap":"Amount_tipsWrap__2lsxn"};